import { ApplicationState } from 'application/redux';
import { connect } from 'react-redux';
import AnonymizerComponent from './anonymizer-component';
import { deleteHashById, fetchHashByAid, fetchHashById } from './services/hashes';
import { createService, deleteService, fetchAllServices, updateService } from './services/services';

const mapStateToProps = (state: ApplicationState) => ({
  services: state.management.anonymizer.services,
  hash: state.management.anonymizer.hash,
  service: state.management.anonymizer.service
})

export default connect(mapStateToProps, {
  fetchAllServices,
  createService,
  updateService,
  deleteService,
  fetchHashById,
  fetchHashByAid,
  deleteHashById,
})(AnonymizerComponent)
